import { EventsListingState } from '../types';
import { ReduxState } from '../types';

/**
 * @param {ReduxState} state - The Redux state.
 * @returns {EventsListingState} The Events Listing state.
 */
export const navSelector = (state) => state.eventsListing.nav;
